import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { map } from 'rxjs';
import type { Role } from '../models/auth.model';
import { AuthService } from '../services/auth.service';

/** Home de cada papel: Owner/Member → /dashboard, Partner → /parceiro. */
export function homeForRole(role: Role | null): string {
  return role === 'Partner' ? '/parceiro' : '/dashboard';
}

/**
 * Autoriza a rota se o papel do usuário está entre `roles`.
 * Caso contrário redireciona à home do papel. A autorização real é do back;
 * este guard é conveniência de navegação.
 */
export function roleGuard(roles: Role[]): CanActivateFn {
  return () => {
    const auth = inject(AuthService);
    const router = inject(Router);

    return auth.ensureUser().pipe(
      map((user): boolean | UrlTree => {
        if (!user) return router.parseUrl('/login');
        return roles.includes(user.role) ? true : router.parseUrl(homeForRole(user.role));
      }),
    );
  };
}
